import React, { FC } from "react";
import { BreadCrumbsItem } from "./BreadCrumbsItem";
import { IBreadCrumbsItem } from "./types";

interface Props {
  className?: string;
  items: IBreadCrumbsItem[];
}

export const BreadCrumbs: FC<Props> = ({ className, items }) => {
  if (!items?.length) return null;

  return (
    <div className={className}>
      <ul className="flex items-center">
        {items.map((item) => (
          <BreadCrumbsItem key={item.title + item.path} {...item} />
        ))}
      </ul>
    </div>
  );
};
